import React from "react";
import SaasProductWizard from "../index";

function Office365Wizard() {
  return <SaasProductWizard productType="office-365" />;
}

export default Office365Wizard;